import { render, staticRenderFns } from "./AssessmentsRevision.vue?vue&type=template&id=0c7ec3f2"
import script from "./AssessmentsRevision.vue?vue&type=script&lang=js"
export * from "./AssessmentsRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports